// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2ELRX","label":"Section_label__20nOZ","contentWrap":"Section_contentWrap__11AZz","footer":"Section_footer__3lsAb","footerInner":"Section_footerInner__1RJuL"};